import { BaseModel, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import DigitalLectureFilterGroup from './DigitalLectureFilterGroup'

export default class DigitalLectureFilters extends BaseModel {
  static override constructorName = 'DigitalLectureFilters'

  categories: DigitalLectureFilterGroup = new DigitalLectureFilterGroup(null)
  tags: DigitalLectureFilterGroup = new DigitalLectureFilterGroup(null)
  'popular_tags': DigitalLectureFilterGroup = new DigitalLectureFilterGroup(null)
  speakers: DigitalLectureFilterGroup = new DigitalLectureFilterGroup(null)
  'popular_speakers': DigitalLectureFilterGroup = new DigitalLectureFilterGroup(null)
  educations: DigitalLectureFilterGroup = new DigitalLectureFilterGroup(null)
  'popular_educations': DigitalLectureFilterGroup = new DigitalLectureFilterGroup(null)
  companies: DigitalLectureFilterGroup = new DigitalLectureFilterGroup(null)
  'popular_companies': DigitalLectureFilterGroup = new DigitalLectureFilterGroup(null)

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      this.categories = new DigitalLectureFilterGroup(data.categories)
      this.tags = new DigitalLectureFilterGroup(data.tags)
      this.popular_tags = new DigitalLectureFilterGroup(data.popular_tags)
      this.speakers = new DigitalLectureFilterGroup(data.speakers)
      this.popular_speakers = new DigitalLectureFilterGroup(data.popular_speakers)
      this.educations = new DigitalLectureFilterGroup(data.educations)
      this.popular_educations = new DigitalLectureFilterGroup(data.popular_educations)
      this.companies = new DigitalLectureFilterGroup(data.companies)
      this.popular_companies = new DigitalLectureFilterGroup(data.popular_companies)
    }
  }
}

registerModel(DigitalLectureFilters)
